import { JsonObject, JsonProperty } from 'json2typescript'
import Address from '@/services/models/Address'
import PersonalDetails from '../PersonalDetails'
import VehicleClaim from './VehicleClaim'
import VehicleConviction from './VehicleConviction'

@JsonObject('VehicleDriverValue')
export default class VehicleDriver extends PersonalDetails {
  @JsonProperty('licenceNumber', String)
  licenceNumber: string | null = null

  @JsonProperty('licenceType', String)
  licenceType = ''

  @JsonProperty('licenceHeldYears', String, true)
  licenceHeldYears: string | null = null

  @JsonProperty('hasAccessToRegularVehicleUse', Boolean, true)
  hasAccessToRegularVehicleUse: boolean | null = null

  @JsonProperty('regularUseVehicleDetail', String, true)
  regularUseVehicleDetail: string | null = null

  @JsonProperty('relationshipToPolicyHolder', String, true)
  relationshipToPolicyHolder: string | null = null

  @JsonProperty('address', Address)
  address: Address | null = null

  @JsonProperty('hasClaims', Boolean)
  hasClaims: boolean | null = null

  @JsonProperty('claims', [VehicleClaim])
  claims: VehicleClaim[] = []

  @JsonProperty('hasAccessToAnotherVehicle', Boolean)
  hasAccessToAnotherVehicle = false

  @JsonProperty('driverToVehicles', [String])
  driverToVehicles: string[] | null = null

  @JsonProperty('proposerHasAccessToAdditionalDriverLicence', Boolean)
  proposerHasAccessToAdditionalDriverLicence: boolean | null = null

  @JsonProperty('hasConvictions', Boolean)
  hasConvictions: boolean | null = null

  @JsonProperty('convictions', [VehicleConviction])
  convictions: VehicleConviction[] = []

  @JsonProperty('occupation', String, true)
  occupation: string | null = null

  @JsonProperty('employmentType', String, true)
  employmentType: string | null = null

  @JsonProperty('businessCategory', String, true)
  businessCategory: string | null = null
}
